import React from 'react';
import headerBlob from '../../../images/blobs/header-blob.svg';
import styles from './burger.module.scss';

export function BurgerMenu(props) {
  const { isOpen, onClick } = props;
  return (
    <div className={styles.burgerContainer}>
      <img src={headerBlob} alt="Mobile menu button background" role="presentation" />
      <button
        name="menu-button"
        aria-label="Toggle menu"
        className={`${styles.burger} ${isOpen && styles.active}`}
        onClick={onClick}
        type="button"
      >
        <span className={styles.box}>
          <span className={styles.inner} />
        </span>
      </button>
    </div>
  );
}

export default BurgerMenu;
